import {
  type TypedUseSelectorHook,
  useDispatch,
  useSelector,
} from 'react-redux';
import { persistReducer } from 'redux-persist';

import { configureStore } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';

import auth from '~modules/auth/store/auth-slice';

import tenantAuth from '~tenant-modules/auth/store/tenant-auth-slice';

import drawer from '~system/store/drawer/drawer-slice';
import formMode from '~system/store/form-mode/form-mode.slice';
import mobileMenu from '~system/store/mobile-menu/mobile-menu-slice';
import modal from '~system/store/modal/modal-slice';
import scope from '~system/store/scope/scope-slice';
import { setStoreAccessor } from '~system/store/store-accessor';
import toast from '~system/store/toast/toast-slice';

const authPersistConfig = {
  key: 'auth',
  storage,
};

const tenantAuthPersistConfig = {
  key: 'tenantAuth',
  storage,
};

const scopePersistConfig = {
  key: 'scope',
  storage,
};

const formModePersistConfig = {
  key: 'formMode',
  storage,
};

const persistedAuth = persistReducer(authPersistConfig, auth);
const persistedTenantAuth = persistReducer(tenantAuthPersistConfig, tenantAuth);
const persistedScope = persistReducer(scopePersistConfig, scope);
const persistedFormMode = persistReducer(formModePersistConfig, formMode);

export const store = configureStore({
  reducer: {
    // auth,
    // tenantAuth,
    // scope,
    auth: persistedAuth,
    tenantAuth: persistedTenantAuth,
    scope: persistedScope,
    toast,
    modal,
    drawer,
    mobileMenu,
    formMode: persistedFormMode,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

setStoreAccessor(store);

export type AppState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<AppState> = useSelector;
